var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpireToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 354.604,
    height: 73.999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.182,
    x2: 0.408,
    y1: 7.581,
    y2: 1.884,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#875fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18e9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: -0.404,
    x2: 0.573,
    y1: 2.023,
    y2: 0.232
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 0.356,
    x2: 0.635,
    y1: 0.948,
    y2: -0.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 0.273,
    x2: 0.592,
    y1: 1.378,
    y2: 0.138
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M1094.571 1395.778h-25.649l-5.443 9.328 36.523.06Z",
    "data-name": "Path 2273",
    transform: "translate(-1030.314 -1395.778)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1041.441 1395.778h-9.425l-12.644 21.852 5.182 8Z",
    "data-name": "Path 2274",
    transform: "translate(-1010.666 -1395.778)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1051.969 1477h13.059l-3.524 6.426h-30.885l-21.69-37.468-5.257 9.278 21.35 36.9h42.907l13.106-23.008h-33.212Z",
    "data-name": "Path 2275",
    transform: "translate(-1003.673 -1418.131)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1091.549 1424.187h-43.541l-11.815 21.35 12.437 21.765h9.949l-12.022-21.557 7.462-13.266h31.714l5.182 8.706h-32.75l-2.073 4.353 2.073 3.938h42.291l3.31-3.938Z",
    "data-name": "Path 2276",
    transform: "translate(-1018.159 -1408.433)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#18e9d9",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.507 39.168v1.527a1.83 1.83 0 0 0 1.138 1.542 7.8 7.8 0 0 0 3.653.644h3.443q.689 0 .883.374a2.5 2.5 0 0 1 .2 1.124 2.6 2.6 0 0 1-.2 1.137q-.194.39-.883.39h-3.563q-8.475 0-8.475-5.211v-6.5q0-5.21 8.475-5.21h6.917q4.493 0 6.484 1.287a4.35 4.35 0 0 1 1.991 3.923v3.444a1.7 1.7 0 0 1-.329 1.2 2.2 2.2 0 0 1-1.468.329Zm0-2.965h16.26v-2.006a1.77 1.77 0 0 0-1.123-1.617 8.7 8.7 0 0 0-3.668-.568h-6.678a7.9 7.9 0 0 0-3.653.629 1.82 1.82 0 0 0-1.138 1.557Z",
    "data-name": "Path 2277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.419 46.025a3 3 0 0 1-1.437-.269 1.19 1.19 0 0 1-.479-1.138V34.197a1.82 1.82 0 0 0-1.018-1.557 7.16 7.16 0 0 0-3.533-.629h-1.677a11 11 0 0 0-2.081.165 4.3 4.3 0 0 0-1.332.464 1.8 1.8 0 0 0-.719.7 1.8 1.8 0 0 0-.209.854v10.421a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.438.269 2.65 2.65 0 0 1-1.452-.3 1.25 1.25 0 0 1-.434-1.108V34.193a1.84 1.84 0 0 0-.209-.854 1.8 1.8 0 0 0-.719-.7 4.3 4.3 0 0 0-1.333-.464 11 11 0 0 0-2.081-.165h-1.677a7.16 7.16 0 0 0-3.534.629 1.82 1.82 0 0 0-1.018 1.557v10.421a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.438.269 2.9 2.9 0 0 1-1.422-.269 1.21 1.21 0 0 1-.464-1.138V34.196a4.33 4.33 0 0 1 2.021-3.923 10.55 10.55 0 0 1 5.675-1.287h2.964q3.773 0 5.6 1.5 1.857-1.5 5.63-1.5h2.964a10.55 10.55 0 0 1 5.675 1.287 4.33 4.33 0 0 1 2.021 3.923v10.421a1.21 1.21 0 0 1-.464 1.138 2.9 2.9 0 0 1-1.424.27",
    "data-name": "Path 2278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.686 49.529a1.19 1.19 0 0 1-.479 1.137 3 3 0 0 1-1.438.27 2.9 2.9 0 0 1-1.422-.27 1.21 1.21 0 0 1-.464-1.137V34.197q0-5.21 8.474-5.21h7.187q8.472 0 8.474 5.21v6.5q0 5.211-8.474 5.211h-11.858Zm11.738-6.648a7.94 7.94 0 0 0 3.653-.628 1.82 1.82 0 0 0 1.139-1.558v-6.5a1.83 1.83 0 0 0-1.139-1.542 7.8 7.8 0 0 0-3.653-.644h-6.947a7.8 7.8 0 0 0-3.653.644 1.83 1.83 0 0 0-1.138 1.542v8.684Z",
    "data-name": "Path 2279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.082 25.933a1.7 1.7 0 0 1 .554-1.407 3.87 3.87 0 0 1 3.623 0 2.064 2.064 0 0 1 0 2.814 3.87 3.87 0 0 1-3.623 0 1.7 1.7 0 0 1-.554-1.407m4.282 18.685a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.437.269 2.9 2.9 0 0 1-1.422-.269 1.21 1.21 0 0 1-.464-1.138V30.482a1.21 1.21 0 0 1 .464-1.138 2.9 2.9 0 0 1 1.422-.269 3 3 0 0 1 1.437.269 1.2 1.2 0 0 1 .479 1.138Z",
    "data-name": "Path 2280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.15 28.987q.688 0 .884.389a2.6 2.6 0 0 1 .194 1.138 2.5 2.5 0 0 1-.194 1.122q-.2.375-.884.375h-2.336a6 6 0 0 0-3.084.568 1.8 1.8 0 0 0-.869 1.588v10.45a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.438.269 2.9 2.9 0 0 1-1.422-.269 1.21 1.21 0 0 1-.464-1.138v-10.45a4.32 4.32 0 0 1 1.991-3.893 10.66 10.66 0 0 1 5.764-1.287Z",
    "data-name": "Path 2281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.318 39.168v1.527a1.83 1.83 0 0 0 1.138 1.542 7.8 7.8 0 0 0 3.653.644h3.444q.689 0 .883.374a2.5 2.5 0 0 1 .2 1.124 2.6 2.6 0 0 1-.2 1.137q-.195.39-.883.39h-3.563q-8.475 0-8.474-5.211v-6.5q0-5.21 8.474-5.21h6.917q4.492 0 6.483 1.287a4.35 4.35 0 0 1 1.991 3.923v3.444a1.68 1.68 0 0 1-.329 1.2 2.2 2.2 0 0 1-1.467.329Zm0-2.965h16.26v-2.006a1.77 1.77 0 0 0-1.123-1.617 8.7 8.7 0 0 0-3.668-.568h-6.678a7.94 7.94 0 0 0-3.653.629 1.82 1.82 0 0 0-1.138 1.557Z",
    "data-name": "Path 2282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.874 28.987v-3.5a1.21 1.21 0 0 1 .464-1.137 2.9 2.9 0 0 1 1.423-.27 3 3 0 0 1 1.437.27 1.19 1.19 0 0 1 .479 1.137v3.5h6.318q.689 0 .883.389a2.6 2.6 0 0 1 .2 1.138 2.5 2.5 0 0 1-.2 1.122q-.194.375-.883.375h-6.318v12.606a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.437.269 2.9 2.9 0 0 1-1.423-.269 1.21 1.21 0 0 1-.464-1.138V32.012h-1.708q-.688 0-.883-.375a2.5 2.5 0 0 1-.195-1.122 2.6 2.6 0 0 1 .195-1.138q.194-.389.883-.389Z",
    "data-name": "Path 2283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.061 34.197q0-5.21 8.474-5.21h6.529q8.473 0 8.474 5.21v6.5q0 5.211-8.474 5.211h-6.529q-8.474 0-8.474-5.211Zm19.674 0a1.82 1.82 0 0 0-1.138-1.557 7.94 7.94 0 0 0-3.653-.629h-6.288a7.9 7.9 0 0 0-3.653.629 1.82 1.82 0 0 0-1.138 1.557v6.5a1.83 1.83 0 0 0 1.138 1.542 7.77 7.77 0 0 0 3.653.644h6.288a7.8 7.8 0 0 0 3.653-.644 1.83 1.83 0 0 0 1.138-1.542Z",
    "data-name": "Path 2284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.886 35.665 12.277-6.468a2.5 2.5 0 0 1 .883-.27 13 13 0 0 1 1.422-.059 1.9 1.9 0 0 1 1.033.269.92.92 0 0 1 .435.839.9.9 0 0 1-.24.659 2.3 2.3 0 0 1-.6.419l-12.038 6.319 12.247 6.2a1.38 1.38 0 0 1 .869 1.257.96.96 0 0 1-.524.929 3.6 3.6 0 0 1-1.573.269 6 6 0 0 1-1.512-.149 3.2 3.2 0 0 1-.793-.3l-11.888-6.289v5.33a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.437.269 2.9 2.9 0 0 1-1.422-.269 1.21 1.21 0 0 1-.464-1.138V25.482a1.21 1.21 0 0 1 .464-1.137 2.9 2.9 0 0 1 1.422-.27 3 3 0 0 1 1.437.27 1.19 1.19 0 0 1 .479 1.137Z",
    "data-name": "Path 2285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.879 39.168v1.527a1.83 1.83 0 0 0 1.138 1.542 7.76 7.76 0 0 0 3.653.644h3.444q.689 0 .883.374a2.5 2.5 0 0 1 .2 1.124 2.6 2.6 0 0 1-.2 1.137q-.195.39-.883.39h-3.563q-8.475 0-8.475-5.211v-6.5q0-5.21 8.475-5.21h6.917q4.492 0 6.484 1.287a4.35 4.35 0 0 1 1.991 3.923v3.444a1.7 1.7 0 0 1-.329 1.2 2.2 2.2 0 0 1-1.468.329Zm0-2.965h16.26v-2.006a1.77 1.77 0 0 0-1.123-1.617 8.7 8.7 0 0 0-3.669-.568h-6.678a7.9 7.9 0 0 0-3.653.629 1.82 1.82 0 0 0-1.138 1.557Z",
    "data-name": "Path 2286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.013 46.025a2.9 2.9 0 0 1-1.422-.269 1.21 1.21 0 0 1-.464-1.138V34.197q0-5.21 8.474-5.21h6.529q8.474 0 8.475 5.21v10.421a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.437.269 2.9 2.9 0 0 1-1.423-.269 1.21 1.21 0 0 1-.464-1.138V34.197a1.82 1.82 0 0 0-1.137-1.557 7.94 7.94 0 0 0-3.654-.629h-6.288a7.9 7.9 0 0 0-3.653.629 1.82 1.82 0 0 0-1.139 1.557v10.421a1.2 1.2 0 0 1-.479 1.138 3 3 0 0 1-1.439.269",
    "data-name": "Path 2287"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpireToken);
export default __webpack_public_path__ + "static/media/empireToken.153d774f213152d5c5540cee146e072e.svg";
export { ForwardRef as ReactComponent };